export default __webpack_public_path__ + "static/media/logo_mobile.7e84e83b.png";